export default "__VITE_ASSET__UZXA4FJ8__"